import { createContext, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import languages from "../assets/data/languages.json";

export const TranslatorContext = createContext();

export const TranslatorProvider = ({ children }) => {

    const { t } = useTranslation();

    const currentLanguageCode = "es"; // Forzar inglés
    const currentLanguage = languages.find((language) => language.code === currentLanguageCode) || languages[0];

    function n(number) {
        const formatter = new Intl.NumberFormat(currentLanguage.tag);
        return formatter.format(number);
    }

    function c(number) {
        const formatter = new Intl.NumberFormat(currentLanguage.tag, { 
            style: 'currency', 
            currency: currentLanguage.currency,
            minimumFractionDigits: 2
        });
        return formatter.format(number);
    }



    useEffect(()=> {
        document.querySelector('html').dir = currentLanguage?.dir;
        document.querySelector('html').lang = currentLanguage?.code;
        console.log("Language changed to:", currentLanguage?.code);
    }, [currentLanguage]);

    return (
        <TranslatorContext.Provider value={{ t, n, c, currentLanguage }}>
            { children }
        </TranslatorContext.Provider>
    )       
}